/**
 * Shared Devices table-mode options (#999 Story 3.9 / #1401).
 *
 * Devices embeds the six `*ConfigurationList` tables — one options seam so
 * statusInColumn / scroll ownership / location chrome stay consistent.
 */

export const DEVICES_TABLE_MODE = {
  readOnly: true as const,
  hideLocationColumn: true as const,
  /** Devices: STATUS pills in-column; no EXISTING/NEW section headers. */
  statusInColumn: true as const,
  /** Nest under RequestDetail scroll — avoids nested ScrollView vs drag. */
  embeddedInParentScroll: true as const,
  isLoading: false as const,
};

export type DevicesTableReorderSectionHandler = (
  section: 'existing' | 'new',
  fromIndex: number,
  toIndex: number,
) => void;

export function buildDevicesTableListProps(params: {
  allowReorder: boolean;
  onReorderSection?: DevicesTableReorderSectionHandler;
  disabled: boolean;
  resolveLocationTagName?: (
    locationTagId: number | null | undefined,
  ) => string | null;
}): typeof DEVICES_TABLE_MODE & {
  allowReorder: boolean;
  onReorderSection?: DevicesTableReorderSectionHandler;
  disabled: boolean;
  resolveLocationTagName?: (
    locationTagId: number | null | undefined,
  ) => string | null;
} {
  return {
    ...DEVICES_TABLE_MODE,
    allowReorder: params.allowReorder,
    onReorderSection: params.allowReorder ? params.onReorderSection : undefined,
    disabled: params.disabled,
    resolveLocationTagName: params.resolveLocationTagName,
  };
}
